import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SUPPORTED_LANGUAGES } from '@/constants/constants';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const LANG_NAMES: Record<string, string> = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  pt: 'Português',
  fr: 'Français',
  tr: 'Türkçe',
  ru: 'Русский',
};

export function LangSelector() {
  const { i18n } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const otherLangs = SUPPORTED_LANGUAGES.filter((lang) => lang !== i18n.language).sort((a, b) =>
    LANG_NAMES[a].localeCompare(LANG_NAMES[b]),
  );

  // The language lives in the URL — App.tsx reads segment 1 and calls changeLanguage itself.
  const switchTo = (lang: string) => () =>
    navigate(
      pathname
        .split('/')
        .map((segment, i) => (i === 1 ? lang : segment))
        .join('/'),
    );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="ml-auto flex cursor-pointer items-center gap-2 rounded-md font-mono text-[12px] text-eyebrow transition-colors duration-(--animate-duration-hover) ease-(--ease-standard) hover:text-surface-1 focus-visible:ring-focus">
        <Globe size={14} />
        {LANG_NAMES[i18n.language] ?? i18n.language}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" side="top">
        {otherLangs.map((lang) => (
          <DropdownMenuItem key={lang} onSelect={switchTo(lang)}>
            {LANG_NAMES[lang]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
